export default __webpack_public_path__ + "assets/images/865fecba70b6be7c4cd6871783da3615.png";